import {
    Box,
    Button,
    Card,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    OutlinedInput,
    Select,
    TextField,
    Typography,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import CommonTable from "../../common/CommonTable";
  import { useDispatch, useSelector } from "react-redux";
  import customerActions from "../../redux/customer/actions";
  import BluePrimaryButton from "../../common/button/bluePrimaryButton";
  import masterActions from "../../redux/master/actions";
  import * as XLSX from "xlsx";
  import { DatePicker } from "@mui/x-date-pickers";
  import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
  import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
  
  export default function Index() {
    const dispatch = useDispatch();
    const [courseid, setCourseId] = useState(0);
    const [section, setSection] = useState("");
    const [questionId, setQuestionId] = useState("");
  
    const { courseList } = useSelector((state) => state.masterReducer);
    const { uniqueObjections } = useSelector((state) => state.customerReducer);
    const [courseError, setCourseError] = useState("");
    const [examDate, setExamdate] = useState(null);

  
    useEffect(() => {
      dispatch({ type: masterActions.GET_COURSE_LIST });
    }, []);
  
    const onChangeCourse = (e) => {
      setCourseId(e.target.value);
      setCourseError("");
    };
  
    const handleSectionChange = (e) => {
      setSection(e.target.value);
    };
  
    const handleQuestionIdChange = (e) => {
      setQuestionId(e.target.value);
    };
  
    const handleExamdateChange = (newValue) => {
      setExamdate(newValue);
    };
  
    const handleGenerate = () => {
      if (courseid === 0) {
        setCourseError("Course is required");
        return;
      }
  
      dispatch({
        type: customerActions.GET_UNIQUE_OBJECTION_REPORT,
        payload: { 
          courseid: courseid, 
          examDate: examDate ? examDate.format("YYYY-MM-DD") : "",
          section: section,
          question_id: questionId 
        },
      });
    };
  
    const handleDownloadExcel = () => {
      if (!uniqueObjections || uniqueObjections.length === 0) return;
  
      const data = uniqueObjections.map((item, index) => ({
        "Sr.No": index + 1,
        "Candidate Roll No": item?.rollno ?? "N/A",
        "Exam Name": item?.exam_name ?? "N/A",
        "Exam Date": item?.exam_date
            ? new Date(item.exam_date).toLocaleDateString("en-GB")
            : "N/A",
            "Section": item?.section ?? "N/A",
        "Question ID": item?.question_id ?? "N/A",
        "Total Objection Count": item?.total_objection_count ?? "0",
        "Unique Objection Answer option": item?.unique_objection_count ?? "0",
    }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Unique Objection Report");
  
      const wscols = [
        { wch: 10 }, 
        { wch: 30 }, 
        { wch: 20 }, 
        { wch: 20 }, 
        { wch: 15 }, 
        { wch: 10 }, 
        { wch: 15 }, 
        { wch: 15 },
      ];
      worksheet["!cols"] = wscols;
  
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const address = XLSX.utils.encode_cell({ r: 0, c: C });
        if (!worksheet[address]) continue;
        worksheet[address].s = {
          font: { bold: true },
          alignment: { horizontal: "center", vertical: "center" },
        };
      }
  
      XLSX.writeFile(workbook, "Unique Objection Report.xlsx");
    };
  
    const applicationStatusColumns = [
        { name: "Sr.No", dataIndex: "srNo" },
        { name: "Candidate Roll No", dataIndex: "rollno" },
        { name: "Exam Name", dataIndex: "exam_name" },
        { name: "Exam Date", dataIndex: "exam_date" },
        { name: "Section", dataIndex: "section" },
        { name: "Question ID", dataIndex: "question_id" },
        { name: "Total Objection Count", dataIndex: "total_objection_count" },
        { name: "Unique Objection Answer option", dataIndex: "unique_objection_count" },
    ];
    
    const tableData = Array.isArray(uniqueObjections)
        ? uniqueObjections.map((item, index) => ({
            srNo: index + 1,
            rollno: item?.rollno ?? "N/A",
            exam_name: item?.exam_name ?? "N/A",
            exam_date: item?.exam_date
                ? new Date(item.exam_date).toLocaleDateString("en-GB")
                : "N/A",
                section: item?.section ?? "N/A",
            question_id: item?.question_id ?? "N/A",
            total_objection_count: item?.total_objection_count ?? "0",
            unique_objection_count: item?.unique_objection_count ?? "0",
        }))
        : [];

    return (
      <>
        <Box
          sx={{
            margin: "1rem auto",
            backgroundColor: "rgba(255, 255, 255, 1)",
            borderRadius: "8px",
            padding: "10px",
          }}
        >
          <Card sx={{ p: 2 }}>
            <Typography>Unique Objection Report </Typography>
  
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12} sm={6} md={4}>
                <FormControl error={!!courseError} sx={{ width: "100%" }}>
                  <Select
                    size="small"
                    onChange={onChangeCourse}
                    value={courseid}
                    defaultValue={0}
                    sx={{ height: "56px" }}
                  >
                    <MenuItem value={0} selected>
                      Select Course <span style={{ color: "red" }}>*</span>
                    </MenuItem>
                    {courseList?.all
                    ?.filter((course) => course.isactive === "1")
                      ?.map((course, i) => (
                        <MenuItem key={i} value={course.courseid}>
                          {course.coursename}
                        </MenuItem>
                      ))}
                  </Select>
                  {courseError && (
                    <Typography variant="caption" color="error">
                      {courseError}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
  
              <Grid item xs={12} sm={6} md={4}>
                <FormControl
                  sx={{ width: "100%" }}
                  variant="outlined"
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Exam Date (DD/MM/YYYY)"
                      value={examDate}
                      onChange={handleExamdateChange}
                      renderInput={(params) => <TextField {...params} />}
                    />
                  </LocalizationProvider>
                </FormControl>
              </Grid>
  
              <Grid item xs={12} sm={6} md={4}>
                <FormControl sx={{ width: "100%" }} variant="outlined">
                  <InputLabel htmlFor="search-section">
                    Search by Section
                  </InputLabel>
                  <OutlinedInput
                    id="search-section"
                    value={section}
                    onChange={handleSectionChange}
                    label="Search by Section"
                  />
                </FormControl>
              </Grid>
  
              <Grid item xs={12} sm={6} md={4}>
                <FormControl sx={{ width: "100%" }} variant="outlined">
                  <InputLabel htmlFor="search-question-id">
                    Search by Question ID
                  </InputLabel>
                  <OutlinedInput
                    id="search-question-id"
                    value={questionId}
                    onChange={handleQuestionIdChange}
                    label="Search by Question ID"
                  />
                </FormControl>
              </Grid>
  
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                mt={1}
                sx={{ display: "flex", gap: 1 }}
              >
                <Box sx={{ marginTop: { xs: 2, sm: 0 } }}>
                  <BluePrimaryButton
                    title={"Generate Report"}
                    handleSubmit={handleGenerate}
                  />
                </Box>
                <Button
                  onClick={handleDownloadExcel}
                  sx={{
                    backgroundColor: "green",
                    color: "white",
                    height: "40px",
                    borderRadius: "11px",
                    "&:hover": { backgroundColor: "darkgreen" },
                  }}
                >
                  Download Excel
                </Button>
              </Grid>
            </Grid>
  
            <CommonTable
              columnData={applicationStatusColumns}
              tableData={tableData}
            />
          </Card>
        </Box>
      </>
    );
  }